(function( root, $, undefined ) {
  "use strict";

var Scroller = Scroller || {},
    $window = $(window),
    $document = $(document),
    $body = $('body'),
    $view = $('.js-scroller'),
    $wrapper = $('.js-scroller-wrap'),
    $boxes = $view.find('.js-scroll-box'),
    $moveright = 0,
    $moveleft = 0,
    $width = null,
    $spanwidth = null,
    $limit = null,
    $mq = window.matchMedia( "(min-width: 1024px)" ),
    $desktop = false,
    $scrollby = 450;

    if ($mq.matches) {
    	$desktop = true;
    }

    Scroller.init = function(){

    	$view.imagesLoaded()
    	.always( function( instance ){
    		console.log('all images loaded');
    	})
    	.done( function( instance ){
    		console.log('all images loaded successfully');
    		Scroller.run();
    		Scroller.nav();
    	})
    	.fail( function( instance ){
    		console.log('no images loaded');
    	})    	    	
    };

	$document.on('ready', function() {
	"use strict";
	    Scroller.init();
	});

	Scroller.run = function() {

		if ($desktop === true) {

			// because flexbox is a bit unreliable, we'll get the widths of the images and force their parent spans to adjust
			// otherwise, sometimes the spans do not fit the images correctly
			$boxes.find('div span').each(function() {
				$spanwidth = $(this).find('img').width();
				$(this).css({'width':$spanwidth+'px'});
			}).promise().done(function () {
				console.log("spans sized");

				// then we get the parent box width

				$boxes.each(function() {
				 	$width += $(this).width();
				 	console.log('box');
				})

			});

			// to then set the width of the view

			$view.css({
				'width':$width+'px'
			});

			// and get the limit 

			$limit = - ($width - $wrapper.width());

			console.log($width);
		}
	};

	Scroller.nav = function(){

		$(".js-scroll-right").click(function(){

			var $currTrans = $view.css('transform').split(/[()]/)[1];    
		    var $currentPosition = $currTrans.split(',')[4];

		    if ($currentPosition >= $limit) {
			    $moveright = $moveright+$scrollby;
			    $moveleft = $moveleft-$scrollby;	 
			    $view.stop(false,true).css({
			    	'-webkit-transform': 'translateX(-' + $moveright + 'px)',
			    	'transform': 'translateX(-' + $moveright + 'px)'
		    	});	
		    } 
		});

		$(".js-scroll-left").click(function(){

			var $currTrans = $view.css('transform').split(/[()]/)[1];    
		    var $currentPosition = $currTrans.split(',')[4];

		    if ($currentPosition < 0){
			    $moveright = $moveright-$scrollby;
			    $moveleft = $moveleft+$scrollby;	    	
			    $view.stop(false,true).css({
			    	'-webkit-transform': 'translateX(' + $moveleft + 'px)',
			    	'transform': 'translateX(' + $moveleft + 'px)'
			    });	
		    } 

		});		
	};

} ( this, jQuery ));